module.exports = __webpack_public_path__ + "img/watchlist-empty-d.68fe6d5e.svg";